<template>
  <div class="containerMod">
    <div v-if="loading" class="loading-container">
      <div class="loader"></div>
    </div>
    <div v-else>
      <div class="bloqueFicha" v-for="hemero in hemeros" :key="hemero._id">
          <div>
            <img class="portada" v-show="hemero.recorteImg" :src="hemero.recorteImg"/>
            <img class="portada" v-show="!(hemero.recorteImg)" src='@/assets/PortadaND.png'/>
          </div>
          <div class="contenido">
            <div class="linea1">
              {{hemero.titulo}}
            </div>
            <div class="linea2">
              {{ hemero.autores.map((ele) => `${ele.nombre} ${ele.apellidos}`).join(', ') }}
            </div>
            <div class="linea3">
              {{hemero.publicacion}}
              {{hemero.fecha ? (' | ' + hemero.fecha) : `` }}
              {{hemero.pagina ? (' | Pág. ' + hemero.pagina) : `` }}
            </div>
            <div class="linea3">
              {{hemero.ciudad ? (hemero.ciudad) : `` }}
              {{hemero.pais ? (' - ' + hemero.pais) : `` }}
            </div>
            <div class="linea3">
              {{hemero.edicion ? (' Ed. ' + hemero.edicion) : `` }}
            </div>
            <div class="linea3">
              {{hemero.papel ? 'Edición papel' : (hemero.digital ? 'Edición digital' : ``)}}
              {{hemero.papel ? (hemero.digital ? ' | ' + 'Versión digital' : ``) : `` }}
              {{hemero.idioma ? (' | ' + hemero.idioma) : ``}}
            </div>
            <div class="linea3">
              <a :href="hemero.url" target="_blank"> {{hemero.url}} </a>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// import XCerrarModal from './XCerrarModal.vue'
import axios from 'axios'
export default {
  // components: { XCerrarModal },
  name: 'ShowHemeros',
  created () {
    this.URLbase = process.env.VUE_APP_ROOT_API
    this.getHemeros()
  },
  data () {
    return {
      hemeros: [],
      URLbase: '',
      loading: false
    }
  },
  methods: {
    cerrarModal: function () {
      this.$router.go(-1)
    },
    async getHemeros () {
      try {
        this.loading = true
        const url = `${this.URLbase}/hemerografias/getHemeros`
        const res = await axios.get(url)
        this.hemeros = res.data
        this.loading = false
      } catch (error) {
        alert(error)
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
*{
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
.containerMod {
  overflow-y: auto;
  height: 99%;
  width: 100%;
  margin-top: 3px;
  background-color: var(--gr-fo-for);
  color: rgb(2, 74, 108);
}
.bloqueFicha{
  margin-top: 10px;
  padding-bottom: 1px;
  display: grid;
  grid-template-columns: 26% 70%;
}
.portada{
  width: 130px;
  box-shadow: rgb(87, 85, 85) 5px 5px 7px;
}
.portadaND{
  width: 120px;
  height: 170px;
  border: solid 0.5px rgb(63, 193, 253);
  border-radius: 5px;
}
.contenido{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-left: 10px;
  border-bottom: solid 0.5px rgb(136, 166, 180);
  padding-bottom: 25px;
  margin-bottom: 0px;
}
.linea1{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 17px;
  color: rgb(30, 119, 161);
}
.linea2{
  font-size: 15px;
  font-weight:700;
}
.linea3{
  font-size: 15px;
}
.loading-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.loader {
  border: 4px solid transparent;
  border-top-color: #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 2s linear infinite;
  margin: auto;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media screen and (max-width: 576px){
 .containerMod{
  display: flex;
  flex-direction: column;
  align-items: center;
 }
 .bloqueFicha{
  display: flex;
  flex-direction: column;
  width: 90%
  }
  .portada{
    width: 230px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .portadaND{
    width: 200px;
    margin-top: 5px;
    margin-bottom: 15px;
  }
  .linea1, .linea2, .linea3{
    text-align: left;
  }
  .linea2{
    margin:4px 0 4px;
  }
}
</style>
